// extracted by mini-css-extract-plugin
export var hero = "singleproduct-module--hero--3uUWn";
export var herob = "singleproduct-module--herob--3iB2S";
export var herosection = "singleproduct-module--herosection--34X2a";
export var herodes = "singleproduct-module--herodes--3amQN";
export var heroheader = "singleproduct-module--heroheader--32hGQ";
export var herosectionb = "singleproduct-module--herosectionb--be8Cn";
export var imgproduct = "singleproduct-module--imgproduct--GpsHG";
export var salebuttom = "singleproduct-module--salebuttom--305Mr";
export var tablecat = "singleproduct-module--tablecat--3M6-l";
export var hr = "singleproduct-module--hr--2hFGw";